// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1-C9d","head":"Table_head__2p6hw","col":"Table_col__Xi44K"};